<div class="end-screen">
	<ng-content select="[header]"></ng-content>
	<bp-content>
		<ng-content select="[content]"></ng-content>
	</bp-content>
</div>
